export class InboundFileConfig {
	inboundFileDefinitionName = "";
	labID = "";
	active = false;
	continueWithFileConfig = false;
	skipRows = 0;
	fileFormat = FileFormat.CSV;
	fileDelimiter = "";
	inboundFileTableDefinitions: Array<InboundFileTableDefinition> = [];
}

export class InboundFileTableDefinition {
	header = "";
	column: number;
	source = "";
	matchingCriteria = false;
	formatHeaderValue = "";
}

export enum FileFormat {
	TXT = "TXT",
	CSV = "CSV",
	XLS = "XLS",
	XLSX = "XLSX",
}

export enum FileDelimiter {
	TAB = "TAB",
	COMMA = "COMMA",
	SEMICOLON = "SEMICOLON"
}

export class InboundFileUploadComponentDTO{
	file: File;
	inboundFileDefinitionName: string;
	stepName: string;
	actionName: string;
}

export const EVALUATION_SAMPLE_RERUN = "Evaluation Sample Rerun List";